interface LoadingProps {
  size?: 'sm' | 'md' | 'lg'
  text?: string
}

const Loading = ({ size = 'md', text }: LoadingProps) => {
  const sizeClasses = {
    sm: 'w-5 h-5 border-2',
    md: 'w-8 h-8 border-3',
    lg: 'w-12 h-12 border-4',
  }

  return (
    <div className="flex flex-col items-center justify-center p-4">
      <div
        className={`
          ${sizeClasses[size]}
          rounded-full animate-spin
          border-[var(--border-light)] border-t-[var(--accent)]
        `}
      />
      {text && (
        <span className="mt-3 text-sm font-medium text-[var(--text-secondary)] animate-pulse">
          {text}
        </span>
      )}
    </div>
  )
}

export default Loading
